import React from 'react';
import classNames from 'classnames';

import { ReactComponent as IconArrow } from '../../../../../../assets/svgs/icon-arrow-down.svg';
import { CustomHeaderTestIDs, ICON_ARROW_WIDTH } from './constants';

export interface Props {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
  nextMonthButtonDisabled: boolean;
  prevMonthButtonDisabled: boolean;
}

const CustomHeader: React.FC<Props> = ({
  date,
  decreaseMonth,
  increaseMonth,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
}) => {
  const nextMonthIconClassName = classNames('fill-current', 'transform', '-rotate-90', {
    'text-gray-400': nextMonthButtonDisabled,
    'text-gray-500': !nextMonthButtonDisabled,
  });

  const prevMonthClassName = classNames('fill-current', 'transform', 'rotate-90', {
    'text-gray-400': prevMonthButtonDisabled,
    'text-gray-500': !prevMonthButtonDisabled,
  });

  return (
    <div className="m-1 flex justify-between items-center border-none font-medium text-sm">
      <button
        className="p-2"
        data-testid={CustomHeaderTestIDs.PreviousMonthButton}
        disabled={prevMonthButtonDisabled}
        onClick={decreaseMonth}
      >
        <IconArrow className={prevMonthClassName} width={ICON_ARROW_WIDTH} />
      </button>

      {date.toLocaleDateString('en', { month: 'long', year: 'numeric' })}

      <button
        className="p-2"
        data-testid={CustomHeaderTestIDs.NextMonthButton}
        disabled={nextMonthButtonDisabled}
        onClick={increaseMonth}
      >
        <IconArrow className={nextMonthIconClassName} width={ICON_ARROW_WIDTH} />
      </button>
    </div>
  );
};

export default CustomHeader;
